import { useEffect, useState } from "react";
import React from "react";
import {
  Col,
  Container,
  Row,
  Input,
  Button,
  Card,
  CardBody,
  Table,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import SimpleBar from "simplebar-react";
import find from "../../../assets/find.svg";
import "simplebar/dist/simplebar.min.css";
import { Link, useNavigate } from "react-router-dom";
import avatar from "../../../assets/images/nav4.svg";
import check from "../../../assets/images/check.svg";
import moreIcon from "../../../assets/images/more.png";
import { get, del, put } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { toast, Bounce } from "react-toastify";
import zIndex from "@mui/material/styles/zIndex";
import { useSelector } from "react-redux";
import Placeholder from "../../../assets/images/Placeholder.gif";
const GymOwnerListing = () => {
  document.title = "Gym Owner Listing | Elevated - Admin Dashboard";
  const [dropdownOpen, setDropdownOpen] = useState({});
  const [staffData, setStaffData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [userRoles, setUserRoles] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState("");
  const [itemPerPage, setItemPerPage] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [selectedRole, setSelectedRole] = useState("By Role");
  const itemsPerPage = 6;

  const navigate = useNavigate();

  const [roleColors, setRoleColors] = useState([]);
  const { userPermissions } = useSelector((state) => state.auth.currentUser);
  // Predefined color list
  const getRandomColor = ["#FFEBEB", "#EBF5F4", "#F1F8F5", "#F5F5F5"];

  const fetchUserRole = async () => {
    try {
      const resp = await get(`${endpoints.roles}`);
      if (resp?.data?.success) {
        const roles = resp?.data?.data;
        setUserRoles(roles);

        // Map roles to colors
        const tempRoleColors = {};
        roles.forEach((role, index) => {
          tempRoleColors[role.name] =
            getRandomColor[index % getRandomColor.length];
        });

        setRoleColors(tempRoleColors);
      }
    } catch (error) {
      console.error("Error fetching user roles:", error);
    }
  };

  useEffect(() => {
    fetchUserRole();
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedSearchTerm(searchTerm), 300);
    return () => clearTimeout(handler);
  }, [searchTerm]);

  const fetchStaff = async (page, searchQuery = "", userRole = "") => {
    setLoading(true);
    try {
      const response = await get(
        `${endpoints.staff}?filter=active&limit=${itemsPerPage}&page=${page}&role=gymOwner&search=${searchQuery} `
      );

      setStaffData(response.data?.data || []);
      setTotalPages(response.data?.totalPages || 1);
      setItemPerPage(response.data?.data?.length || 0);
      setTotalItems(response.data?.totalCount || 0);
    } catch (error) {
      console.error("Error fetching gym owner data:", error);
      setStaffData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStaff(currentPage, debouncedSearchTerm);
  }, [currentPage, debouncedSearchTerm]);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) setCurrentPage(page);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleSelectChange = async (action, staffId) => {
    switch (action) {
      case "delete":
        await deleteStaff(staffId);
        break;
      case "update":
        const updatedData = {};
        await updateStaff(staffId, updatedData);
        break;

      default:
        break;
    }
  };
  const deleteStaff = async (staffId) => {
    try {
      await del(`${endpoints.staff}/${staffId}`);
      setStaffData((prevData) =>
        prevData.filter((staff) => staff.id !== staffId)
      );
      toast.success("Gym Owner Deleted Successfully", {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      });
      fetchStaff(currentPage);
    } catch (error) {
      console.error("Error deleting gym owner:", error);
    }
  };

  const updateStaff = async (staffId, updatedData) => {
    try {
      await put(`${endpoints.staff}/${staffId}`, updatedData);
      fetchStaff(currentPage, searchTerm);
    } catch (error) {
      console.error("Error updating gym owner:", error);
    }
  };

  const handleEditStaff = (staffId, gymId) => {
    navigate(`/add-gymowner?staffId=${staffId}`);
  };

  const handleStaffDetail = async (staffId) => {
    try {
      navigate(`/gymowner-Detail`, { state: { staffId: staffId } });
    } catch (error) {
      console.error("Error fetching gym owner details:", error);
    }
  };
  const formatPermissionName = (permission) => {
    return permission
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/_/g, " ")
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };
  const toggleDropdown = (staffId) => {
    setDropdownOpen((prevState) => ({
      ...prevState,
      [staffId]: !prevState[staffId],
    }));
  };
  const handleClearFilters = () => {
    setSelectedRole("By Role");
    setSearchTerm("");
    setCurrentPage(1);
    fetchStaff(1);
  };
  const findColor = (name) => {
    const index = roleColors.findIndex((role) => role === name);
    return getRandomColor[index];
  };
  return (
    <div className="">
      <Container fluid>
        <Row>
          <Col>
            <Card className="rounded-4">
              <CardBody>
                <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center mb-3">
                  {/* Title and Search Section */}
                  <div className="d-flex flex-column flex-sm-row justify-content-start align-items-center gap-2 w-100 mt-2 mt-sm-0">
                    {/* Title */}
                    <span className="font-size-20 fw-bold primary-black ff-sora mb-2 mb-sm-0">
                      Gym Owner
                    </span>

                    {/* Search Bar */}
                    <div
                      className="w-100 w-sm-auto bg-light ff-sora d-flex justify-content-between align-items-center"
                      style={{
                        borderRadius: "12px",
                        height: "48px",
                        maxWidth: "400px",
                      }} // Added maxWidth
                    >
                      {/* Search Icon */}
                      <img
                        src={find}
                        alt="Search"
                        className="light-black"
                        style={{
                          height: "24px",
                          width: "24px",
                          marginLeft: "10px",
                        }}
                      />

                      {/* Search Input */}
                      <Input
                        type="text"
                        name="search"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        className="ff-sora light-black font-size-14 fw-normal w-100"
                        style={{ background: "transparent", border: "none" }}
                        placeholder="Search"
                      />
                    </div>
                  </div>

                  {/* Add New Button Section */}
                  <div className="d-flex flex-column flex-sm-row justify-content-end align-items-center gap-2 w-100 mt-2 mt-sm-0">
                    <Link to="/add-gymowner" className="w-auto w-sm-100">
                      <Button
                        className="rounded-pill w-auto w-sm-100" // Full width on small screens, auto width on larger screens
                        style={{ minWidth: "120px" }} // Compact width on larger screens
                      >
                        Add New
                      </Button>
                    </Link>
                  </div>
                </div>
                <>
                  <div
                    className="table-responsive hide-scrollbar"
                    style={{
                      height: staffData?.length > 0 ? "500px" : "auto",
                    }}
                  >
                    <Table
                      hover
                      className="table-borderless table-centered table-nowrap"
                    >
                      <thead>
                        <tr>
                          <th className="font-size-14 mb-1 fw-bold ff-sora secondary-black">
                            Id
                          </th>
                          <th className="font-size-14 mb-1 fw-bold ff-sora secondary-black">
                            User
                          </th>
                          <th className="font-size-14 mb-1 fw-bold ff-sora secondary-black">
                            Email
                          </th>
                          <th className="font-size-14 mb-1 fw-bold ff-sora secondary-black">
                            Phone Number
                          </th>{" "}
                          {/* <th className="font-size-14 mb-1 fw-bold ff-sora secondary-black">
                            Permissions
                          </th> */}
                          <th className="font-size-14 mb-1 fw-bold ff-sora secondary-black">
                            Added on
                          </th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody style={{ minHeight: "550px" }}>
                        {loading ? (
                          <tr>
                            <td colSpan={8} className="text-center">
                              <div className="d-flex justify-content-center align-items-center">
                                <div
                                  className="spinner-border"
                                  style={{
                                    width: "3rem",
                                    height: "3rem",
                                    color: "#3BABA6",
                                  }}
                                  role="status"
                                >
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ) : staffData?.length === 0 ? (
                          <></>
                        ) : (
                          staffData.map((staff, index) => (
                            <tr key={index}>
                              <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                                {(currentPage - 1) * itemsPerPage + index + 1}
                              </td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <img
                                    src={
                                      staff?.additionalInfo?.profileImage ==
                                      null
                                        ? avatar
                                        : `${process.env.REACT_APP_IMG_URL}${staff?.additionalInfo?.profileImage}`
                                    }
                                    className="avatar-xs rounded-2 font-size-14 ff-sora fw-normal object-fit-cover me-2"
                                    alt={`${staff?.firstName}'s avatar`}
                                  />
                                  <div>
                                    <h6 className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                                      {staff?.firstName} {staff?.lastName}
                                    </h6>
                                  </div>
                                </div>
                              </td>
                              <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                                {staff?.email || "N/A"}
                              </td>
                              <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                                {staff?.phoneNumber || "N/A"}
                              </td>
                              {/* <td style={{ maxWidth: "300px" }}>
                                <div className="d-flex flex-wrap aligin-items-center gap-2">
                                  {Object?.entries(
                                    staff?.userPermissions || {}
                                  )?.map(([category, permissions], index) => {
                                    const permissionEntries = Object.entries(
                                      permissions
                                    ).filter(([key]) => key !== "selected");

                                    const permissionsToShow =
                                      permissionEntries.slice(0, 4);

                                    return permissionsToShow.map(
                                      ([permissionName], permissionIndex) => {
                                        return (
                                          <span
                                            key={`${category}-${permissionIndex}`}
                                            className="badge bg-light font-size-14 fw-normal ff-sora rounded-5 px-2 py-2 px-2"
                                            style={{ height: "30px" }}
                                          >
                                            {formatPermissionName(
                                              permissionName
                                            )}{" "}
                                          </span>
                                        );
                                      }
                                    );
                                  })}
                                </div>
                              </td> */}
                              <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                                {staff.createdAt
                                  ? new Date(
                                      staff.createdAt
                                    ).toLocaleDateString()
                                  : "N/A"}
                              </td>

                              <td className="">
                                <Dropdown
                                  isOpen={dropdownOpen[staff.id]}
                                  toggle={() => toggleDropdown(staff.id)}
                                  direction="down"
                                >
                                  <DropdownToggle
                                    tag="button"
                                    className="btn btn-link p-0"
                                  >
                                    <img src={moreIcon} alt="More options" />
                                  </DropdownToggle>
                                  <DropdownMenu end>
                                    <DropdownItem
                                      className="fw-normal ff-sora secondary-black font-size-14"
                                      onClick={() =>
                                        handleEditStaff(staff.id, staff.gymId)
                                      }
                                    >
                                      Edit Gym Owner
                                    </DropdownItem>
                                    <DropdownItem
                                      className="fw-normal ff-sora secondary-black font-size-14"
                                      onClick={() =>
                                        handleSelectChange("delete", staff.id)
                                      }
                                    >
                                      Delete Gym Owner
                                    </DropdownItem>
                                    <DropdownItem
                                      className="fw-normal ff-sora secondary-black font-size-14"
                                      onClick={() =>
                                        handleStaffDetail(staff.id)
                                      }
                                    >
                                      Gym Owner Detail
                                    </DropdownItem>
                                  </DropdownMenu>
                                </Dropdown>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>
                    {!loading && staffData?.length === 0 && (
                      <div className="d-flex flex-column align-items-center justify-content-center vh-50">
                        <img
                          src={Placeholder}
                          alt="No record placeholder"
                          className="object-fit-contain img-fluid h-25 w-25 rounded-3 mb-3"
                        />
                        <p className="text-center ff-sora font-size-16 fw-normal">
                          No Record Found!
                        </p>
                      </div>
                    )}
                  </div>
                </>
              </CardBody>
            </Card>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                height: "40px",
                position: "sticky",
                bottom: "0",
                zIndex: "10",
                backgroundColor: "#f5f5f5",
              }}
            >
              <div>
                <span className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                  {`Showing ${Math.min(
                    (currentPage - 1) * itemsPerPage + itemPerPage
                  )} of ${totalItems}`}
                </span>
              </div>
              <div className="d-flex justify-content-center">
                <Button
                  style={{
                    width: "40px",
                    height: "40px",
                    color: "#1f1f1f",
                    borderWidth: "1px",
                    borderColor: currentPage === 1 ? "#f5f5f5" : "#1f1f1f",
                    background: "#f5f5f5",
                    borderRadius: "80px",
                  }}
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  &lt;
                </Button>
                {[...Array(totalPages).keys()]
                  .slice(
                    Math.max(0, currentPage - 2),
                    Math.min(totalPages, currentPage + 1)
                  )
                  .map((page) => (
                    <Button
                      key={page + 1}
                      onClick={() => handlePageChange(page + 1)}
                      style={{
                        width: "40px",
                        height: "40px",
                        color: currentPage === page + 1 ? "white" : "#1f1f1f",
                        background:
                          currentPage === page + 1 ? "#3BABA6" : "#f5f5f5",
                        marginLeft: "10px",
                        marginRight: "10px",
                        borderRadius: "80px",
                        border: 0,
                      }}
                      className={currentPage === page + 1 ? "active" : ""}
                    >
                      {page + 1}
                    </Button>
                  ))}
                <Button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{
                    width: "40px",
                    height: "40px",
                    color: "#1f1f1f",
                    borderWidth: "1px",
                    borderColor:
                      currentPage === totalPages ? "#f5f5f5" : "#1f1f1f",
                    background: "#f5f5f5",
                    borderRadius: "80px",
                  }}
                >
                  &gt;
                </Button>
              </div>
            </div>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                height: "60px",
                position: "sticky",
                bottom: "0",
                zIndex: "10",
              }}
            ></div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default GymOwnerListing;
